import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.archive-credit-card-item.presenters.ArchiveCreditCardItemPresenter`

export default defineMessages({
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Success',
  },
  successMessage: {
    id: `${scope}.successMessage`,
    defaultMessage: 'Item {description} has been archived.',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  genericErrorMessage: {
    id: `${scope}.genericErrorMessage`,
    defaultMessage: 'Unable to archive the credit card item.',
  },
})
